import { AxiosError } from 'axios'
import { UseMutationOptions, useMutation } from 'react-query'
import { projectsApi } from '../projects.api'
import { useLocale } from '@plandi/common'

export const useMutationCreateChatProject = (
  options?: UseMutationOptions<{ id?: number }, AxiosError, number>
) => {
  const locale = useLocale()
  const mutation = useMutation(
    (projectId) => projectsApi.createChatProject(projectId, locale),
    options
  )

  return mutation
}
